import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { ROSTER_NAME_COLUMN_ID, ROSTER_NAME_COLUMN_LABEL } from "./constants";
import { rosterColumnHeader } from "./header";
import { RosterCellValue } from "./roster-cell-value";
import type { ReadOnlyRosterRow } from "./types";

export const ReadOnlyNameCol = (
  width: number,
): ColumnDef<ReadOnlyRosterRow, unknown> => ({
  id: ROSTER_NAME_COLUMN_ID,
  header: rosterColumnHeader(ROSTER_NAME_COLUMN_LABEL),
  enableSorting: false,
  meta: { size: `${width}px` },
  cell: ({ row }) => (
    <Stack align="start" gap={0}>
      <RosterCellValue value={row.original.member.display_name || "-"} />
      <Text
        variant="caption"
        tone="muted"
        className="truncate"
        title={row.original.member.service_titan_employee_id || "-"}
      >
        {row.original.member.service_titan_employee_id || "-"}
      </Text>
    </Stack>
  ),
});
